<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="value-chart-breakdown-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              &times;
            </span>
          </button>

          <h4 class="modal-title">
            Breakdown
          </h4>
        </div>

        <loading-spinner v-if="loading"/>

        <div v-else class="modal-body">
          <table class="table table-striped table-condensed">
            <thead>
            <tr>
              <th class="col-xs-8">
                Company
              </th>

              <th class="col-xs-6">
                Portal
              </th>

              <th class="col-xs-6">
                Date
              </th>

              <th class="col-xs-4 text-right">
                Value
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="row in data">
              <td class="table__ellipsis">
                <router-link
                    :to="'/companies/' + row.company_id + '/orders/' + row.subscription_id"
                    data-dismiss="modal"
                >
                  {{ row.company_name }}
                </router-link>
              </td>

              <td class="table__ellipsis">
                <router-link :to="'/portals/' + row.portal_id" data-dismiss="modal">
                  {{ row.portal_name }}
                </router-link>
              </td>

              <td>
                {{ row.sold_at | date }}
              </td>

              <td class="text-right">
                {{ row.first_partnership_period_value | price }}
              </td>
            </tr>
            </tbody>

            <tfoot>
            <tr>
              <td colspan="4" class="text-right">
                <b>
                  Total: {{ total | price }}
                </b>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  props: {
    user: {
      required: true
    },

    breakdown: {
      required: true
    },

    selectedBreakdown: {
      required: true
    }
  },

  data() {
    return {
      data: null,

      loading: true
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    selectedBreakdown() {
      this.load()
    }
  },

  computed: {
    total() {
      return this.data.reduce((sum, row) => sum + row.first_partnership_period_value, 0)
    }
  },

  methods: {
    load() {
      this.loading = true

      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'first_partnership_period_value'}
        ],
        dimensions: [
          {name: 'company_id'},
          {name: 'company_name'},
          {name: 'portal_id'},
          {name: 'portal_name'},
          {name: 'subscription_id'},
          {name: 'sold_at'}
        ],
        filters: [
          {
            dimension: this.breakdown === 'months' ? 'sold_month' : 'sold_week',
            operator: '=',
            value: this.selectedBreakdown
          },
          {dimension: 'user_id', operator: '=', value: this.user.id}
        ]
      }).then(response => {
        this.data = response.data.data

        this.loading = false
      })
    },

    hide() {
      $(this.$el).modal('hide')
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    }
  }
}
</script>
